__turbopack_context__.v({
  "dense": "LiveStreamStatus-module-scss-module__NlyAia__dense",
  "highlight": "LiveStreamStatus-module-scss-module__NlyAia__highlight",
  "live": "LiveStreamStatus-module-scss-module__NlyAia__live",
  "status": "LiveStreamStatus-module-scss-module__NlyAia__status",
});
